import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PermissionsService } from '../services/permissions.service';

@Component({
  selector: 'app-charges-module',
  templateUrl: './charges-module.component.html',
  styleUrls: ['./charges-module.component.scss'],
})
export class ChargesModuleComponent implements OnInit {
  env;

  constructor(public permissionsService: PermissionsService) {
    this.env = environment;
  }

  ngOnInit() {}
}
